import { MeshLambertMaterial as a } from "three";
const t = /* @__PURE__ */ new Map([
  ["opaque", {
    material: new a({ vertexColors: !0 }),
    visible: (e) => e.alpha === 1
  }],
  ["transparent", {
    material: new a({ vertexColors: !0, transparent: !0 }),
    visible: (e) => !!e.alpha && e.alpha < 1
  }]
]);
export {
  t as StandardRenderLayers
};
//# sourceMappingURL=index27.js.map
